<template>
  <div id="Account" class="wrap">
    
    <v-app-bar  class="grey lighten-3 hidden-sm-and-up"  fixed  elevate-on-scroll  >
      <v-layout justify-center align-center>
        <v-icon large color="blue darken-3">mdi-account-circle</v-icon>
        <span class="title blue--text text--darken-3 ml-1"> My Profile</span>
      </v-layout>
    </v-app-bar>
 
    <div class="maxContainer">
      <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8 mt-6">
        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
        <v-layout justify-center align-center class="hidden-sm-and-down">
          <v-icon large color="blue darken-3">mdi-account-circle</v-icon>
          <span class="title blue--text text--darken-3 ml-1"> My Profile</span>
        </v-layout>
        <v-tabs 
          v-model="tab"
          fixed grow class="px-2"
          style="marginTop:60px"
          hide-slider
          > 
          <v-tab active-class="grey darken-3 white--text" style="marginLeft:0px;">
            My Info
          </v-tab>
          <v-tab active-class="grey darken-3 white--text">
            <span class="">Subscription </span>
          </v-tab>
            
          <v-tabs-items v-model="tab">
            <v-tab-item  >
              <Profile/>
            </v-tab-item>

            <v-tab-item >
              <Subscriptions/>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
    </div>
    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tab: null,
        email: '',
        password: '',
        e1: true,
      }
    },
    computed: {
      user() {
        return this.$store.getters.user
      },
      error() {
      return this.$store.getters.error
    }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.go(-1)
        }
      }
    },
    methods: {
      back() {
        this.$router.go("-1");
      },
      login() {
        this.$store.dispatch('loginUser', { email: this.email, password: this.password})
      },
      onDismissed() {
        console.log('dismissed')
        this.$store.dispatch('clearError')
      }
    }
  }
</script>

<style scoped>
 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom: 165px;
    
  }
.container {
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;

}


#buttonRow {
  display:flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}
</style>




// WEBPACK FOOTER //
// src/components/User/Account.vue